export const getStickers = () => {
  const win = window as any
  const box = win.api.Sync.getCurrentSandbox()
  return win.api.Sticker.list(box)
}
